<template>
  <div :class="customClassWrap">
    <slick
      ref="gallery"
      class="gallery-slideshow"
      v-bind="settings"
      @beforeChange="showSlideIndex"
      @init="onInit"
    >
      <template v-if="customArrows" #prevArrow="arrowOption">
        <slot name="prev-arrow" :prevOption="arrowOption"></slot>
      </template>
      <template v-if="customArrows" #nextArrow="arrowOption">
        <slot name="next-arrow" :nextOption="arrowOption"></slot>
      </template>
      <slot name="slide-contents"></slot>
      <template v-if="customDots" #customPaging="page">
        <slot name="custom-dots" :dotsPage="page"></slot>
      </template>
    </slick>
    <slot name="slide-counter" v-bind="{ oldSlideIndex, newSlideIndex, maxSlides, goTo }"></slot>
  </div>
</template>

<script>
// https://github.com/gs-shop/vue-slick-carousel
import Slick from 'vue-slick-carousel'
// import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  components: { Slick },

  props: {
    customClassWrap: {
      type: String,
      default: 'carousel-wrap',
    },
    settings: {
      type: Object,
      default() {
        return {
          arrows: true,
          dots: true,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true
        }
      },
    },
    customArrows: {
      type: Boolean,
      default: false,
    },
    customDots: {
      type: Boolean,
      default: false,
    },
    maxSlides: {
      type: Number,
      default: 1,
    },
    initCallback:{
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      oldSlideIndex: null,
      newSlideIndex: 0,
    }
  },

  methods: {
    showSlideIndex(oldSlideIndex, newSlideIndex) {
      this.oldSlideIndex = oldSlideIndex
      this.newSlideIndex = newSlideIndex
    },

    goTo (index) {
      this.$refs.gallery.goTo(index)
    },

    onInit () {
      this.$emit('init')
      this.initCallback()
    },
  },
}
</script>
